// extracted by mini-css-extract-plugin
module.exports = {"slidingModal":"WishlistModal_slidingModal__udioa","slideUp":"WishlistModal_slideUp__RaSnI"};